import { getFXBankList } from "@actions/deposit.js";
import FormItem from "@components/formItem";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems.js";
import React from "react";
import MaskInput from "react-maskinput/lib";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput } from "../baseItems";
import Base from "./base";

export default class FxCuzdan extends Base {
	constructor(props) {
		super(props);
		getFXBankList().then((res) => {
			this.setState({ bankList: res.data });
		});
	}

	onSelectBankName(e) {
		this.setState(
			{
				bankName: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedCurrency, bankName, bankList } = this.state;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];
		bankList &&
			Object.keys(bankList).map((v) => {
				let newOpt = { value: v, label: bankList[v] };
				bankOptions.push(newOpt);
			});
		let selectedBank = bankName ? bankOptions.find((o) => o.value === bankName).value : 0;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "bankName" })}>
						<Box>
							<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
							<PaymentSelect
								options={bankOptions}
								value={selectedBank}
								handleSelect={this.onSelectBankName.bind(this)}
							/>
						</Box>
					</FormItem>
					{
						//IF PEP
						bankName ? (
							bankName === "17" ? (
								<FormItem
									onRegister={() =>
										this.registerField({ name: "accountNumber" })
									}>
									<Box>
										<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
										<MaskedInput>
											<MaskInput
												alwaysShowMask={window.IS_MARS ? true : false}
												maskChar="."
												mask="000000000"
												size={9}
												onChange={this.onEnterValue.bind(
													this,
													"accountNumber"
												)}
											/>
										</MaskedInput>
									</Box>
								</FormItem>
							) : (
								<FormItem
									onRegister={() =>
										this.registerField({ name: "accountNumber" })
									}>
									<Box>
										<BoxTitle>{translate("IBAN")}</BoxTitle>
										<MaskedInput>
											<MaskInput
												alwaysShowMask={window.IS_MARS ? true : false}
												maskChar="."
												mask="\T\R00 0000 0000 0000 0000 0000 00"
												size={11}
												onChange={this.onEnterValue.bind(
													this,
													"accountNumber"
												)}
											/>
										</MaskedInput>
									</Box>
								</FormItem>
							)
						) : null
					}
				</BoxWrapper>
			</Content>
		);
	}
	makeExternalPayment() {
		const { accountNumber, bankName, stake, selectedCurrency } = this.state;
		let withdrawData = {
			type: "FxCuzdan",
			bank_id: bankName.toString(),
			iban: accountNumber,
			amount: {
				value: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
